/// <amd-module name="Feed/Legacy/Types/FeedRetentionChanges" />
export interface FeedRetentionChanges {
    active: boolean;
    maximumCount: string;
    daysToKeep: string;
}
